export default __webpack_public_path__ + "static/tb_helles_04_EN-530a02ac794a932611f67349ad42f201.svg";